import type { Event } from 'models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Icon, type MenuProps } from 'ui';
import { generateEhrPortalUrl, routes as routesEhr, useEhrPortalRedirectMutation } from 'features/ehr-portal';

type P = {
  event: Event;
};

export const useTelehealthVisitEventDropdownActions = () => {
  const { t } = useTranslation();
  const { canEditTelehealthEvent } = usePermissions();
  const { isPending: isRedirectingToEhrPortal, mutate: redirectToEhrPortal } = useEhrPortalRedirectMutation();

  return useCallback(
    ({ event }: P) => {
      const actions: MenuProps['items'] = [];

      if (canEditTelehealthEvent({ event })) {
        actions.push({
          disabled: isRedirectingToEhrPortal,
          icon: <Icon icon="pencil-line" />,
          key: 'edit',
          label: t('Edit'),
          onClick() {
            redirectToEhrPortal({
              referrer: generateEhrPortalUrl(routesEhr.calendar({ action: 'edit', eventId: event.id })),
            });
          },
        });
      }

      return actions;
    },
    [canEditTelehealthEvent, isRedirectingToEhrPortal, redirectToEhrPortal, t],
  );
};
